import React from 'react'

const Overlay = () => {
  return (
    <div className='overlayContainer' >
      <div className='overlay3DBanner'>
        <p className='S glwEffect' style={{marginBottom:'-1.5vh', color:'#ffff99'}}>New</p>
        <p className='L glwEffect' style={{color:'#ffff99'}}>SERIES</p>

        <p className='M glwEffect' style={{marginBottom:'-1.9vh'}}>MaxiM</p>
        <p className='L glwEffect' style={{color:'#ffff99'}}>WORKERS</p>
      </div>
    </div>
  )
}

export default Overlay